export const BUSINESS = {
  name: "Pine & Shine Detailing",
  phone: "(206) 428-8432",
  phoneHref: "tel:+12064288432",
  smsHref: "sms:+12064288432",
  email: "pineandshinedetailing@gmail.com",
  emailHref: "mailto:pineandshinedetailing@gmail.com",
  instagram: "https://instagram.com",
  founderAge: 14,
  detailHours: "4+ hours",
};

export const VEHICLE_TYPES = ["Sedan", "SUV", "Truck"];

export const PACKAGES = [
  {
    id: "basic",
    name: "Basic Exterior Wash",
    icon: "car",
    prices: { Sedan: 60, SUV: 75, Truck: 90 },
    features: ["Foam wash", "Wheels cleaned", "Tire shine", "Hand dry"],
    desc: "A crisp, streak-free exterior refresh.",
  },
  {
    id: "interior",
    name: "Interior Cleaning",
    icon: "sparkles",
    prices: { Sedan: 90, SUV: 110, Truck: 130 },
    features: ["Full vacuum", "Wipe down all surfaces", "Windows cleaned", "Light stain removal", "Floor mats cleaned"],
    desc: "Cabin reset — top to bottom.",
  },
  {
    id: "full",
    name: "Full Detail",
    icon: "star",
    badge: "You save $10",
    prices: { Sedan: 140, SUV: 175, Truck: 210 },
    features: ["Complete interior & exterior", "Door jamb cleaning", "Trim dressing", "Tire shine", "Spray sealant"],
    desc: "Inside and out, done right.",
    popular: true,
  },
  {
    id: "premium",
    name: "Premium Detail",
    icon: "gem",
    prices: { Sedan: 220, SUV: 260, Truck: 300 },
    truckPlus: true,
    features: ["Everything in Full Detail", "Clay bar decontamination", "Paint sealant", "Deep interior cleaning", "Plastic trim restoration", "Premium spray wax"],
    desc: "The showroom treatment.",
  },
];

export const ADDONS = [
  { id: "pet", name: "Pet Hair Removal", from: 30, range: "$30–$60" },
  { id: "plastic", name: "Plastic Restoration", from: 40, range: "$40–$70" },
  { id: "engine", name: "Engine Bay Cleaning", from: 50, range: "$50" },
  { id: "stain", name: "Stain Extraction", from: 50, range: "$50–$120" },
];

export const FAQS = [
  { q: "How long does a detail take?", a: "A full or premium detail takes about 4+ hours. I never rush — the time is what makes the difference between a wash and a real detail." },
  { q: "Do you come to me or do I drop off?", a: "Both. I offer mobile service where I come to you, and drop-off is available too. You'll pick your option during booking." },
  { q: "How do I pay?", a: "Payment is in person after the detail is complete — cash or your preferred method. No online payment needed to book." },
  { q: "What days are you open?", a: "I take appointments most days by booking — but I don't work Saturdays. Pick any other day that works for you in the booking form." },
  { q: "What areas do you cover?", a: "Local service in and around town. If you're unsure, text me your location and I'll confirm before your appointment." },
  { q: "Am I experienced enough to trust with your car?", a: "Absolutely. I treat every vehicle like it's my own, take my time, and my reviews speak for the quality of the work. If you're ever not happy, tell me and I'll make it right." },
  { q: "Do you remove pet hair and tough stains?", a: "Yes — pet hair removal and stain extraction are available as add-ons for deeper interior jobs." },
];

export const TRUST_CHAPTERS = [
  { n: "01", title: "Hungry, not hobbyist", text: "I'm 14 and this isn't a side thing to me — it's what I want to be great at. That means I show up early, work harder, and never cut corners to finish faster." },
  { n: "02", title: "Every car is a portfolio", text: "I don't have decades of ads — I have results. Each vehicle I detail is proof, which is why I obsess over the door jambs, vents, and spots most people skip." },
  { n: "03", title: "Honest pricing, honest work", text: "Fair prices, pay in person, no surprises. If something can't be fixed, I'll tell you straight instead of overpromising." },
];
